import { Injectable } from '@angular/core';
import { BaseService } from '@secca/core/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SettingsService } from '@secca/core/services/settings.service';
import { Observable } from 'rxjs';
import {
  MedicalEscortFeeRequestDto,
  MedicalEscortFeeResponseDto
} from '@secca/case/components/case-plans/case-plans/add-service-order/models/MedicalEscortFeeDto';

@Injectable({
  providedIn: 'root'
})
export class MedicalEscortFeeService extends BaseService {
  private readonly medicalEscortFeeUrl = 'calculate-fee/medical-escort-async';

  constructor(private readonly httpClient: HttpClient, private readonly settingsService: SettingsService) {
    super(settingsService);
  }

  calculateMedicalEscortFee(requestDto: MedicalEscortFeeRequestDto): Observable<MedicalEscortFeeResponseDto> {
    let params = new HttpParams();
      params = params.append('customerProfileId', requestDto.customerProfileId?.toString());
      params = params.append('caseType', requestDto.caseType);
      params = params.append('caseCreationDate', requestDto.caseCreationDate instanceof Date ? requestDto.caseCreationDate.toISOString() : requestDto.caseCreationDate);
      params = params.append('commitmentType', requestDto.commitmentType);
      params = params.append('causeLevel1Code', requestDto.causeLevel1Code);
      params = params.append('causeLevel2Code', requestDto.causeLevel2Code);
      params = params.append('medicalEscortStart', requestDto.medicalEscortStart instanceof Date ? requestDto.medicalEscortStart.toISOString() : requestDto.medicalEscortStart);
      params = params.append('medicalEscortEnd', requestDto.medicalEscortEnd instanceof Date ? requestDto.medicalEscortEnd.toISOString() : requestDto.medicalEscortEnd);

    return this.httpClient.get<MedicalEscortFeeResponseDto>(this.baseURL + this.medicalEscortFeeUrl, {
      headers: this.jsonHeaders,
      params: params
    });
  }

}
